/** Available content height in an action dialog, excluding parent/root padding.
 * Null outside that layout: preserve the existing standalone/legacy calculations.
 */
export function dialogAvailableHeight(element) {
  if (!element || typeof element.closest !== 'function' || !element.closest('.action-result-popup__body') || !element.parentElement) return null
  const parent = element.parentElement
  const parentStyle = window.getComputedStyle(parent)
  const ownStyle = window.getComputedStyle(element)
  const padding = style => (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0)
  return Math.max(0, parent.clientHeight - padding(parentStyle) - padding(ownStyle))
}
